import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { generateWorkflowSteps, isWorkflowStepInput } from '@app/helpers/addEditApplication.helpers';
import { IWorkflowStep } from '@app/pages/ssoManager/addEditApplication.enums';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    Workflow: string;
}

export const WorkflowAppConfiguration: React.SFC<IProps> = ({Workflow}: IProps) => {

    const { translation } = useTypedTranslation();

    return (
        <>
            <Grid container justifyContent='space-between' className='configpanel-row'>
            <Grid item xs={12} lg={4} className='configpanel-left'>
                <Box p={2}>
                <h4>{translation('WORKFLOW_ATTRIBUTES_READ')}</h4>
                <ul>
                    {generateWorkflowSteps(Workflow)?.filter(isWorkflowStepInput)
                        .map(({elementval}: IWorkflowStep, index: number) => (
                            <li key={index}>{elementval}</li>
                        ))
                    }
                </ul>
                </Box>
            </Grid>
            <Grid item xs={12} lg={6} className='configpanel-right'>
                <Box p={4}>
                    <div dangerouslySetInnerHTML={{ __html: translation('WORKFLOW_HELP_TEXT') }}></div>
                </Box>
            </Grid>
        </Grid>
        </>
    );
};
